import { apiClient } from './api';
import { API_ENDPOINTS } from '../constants';

export const statisticsService = {
  async getPublicStatistics() {
    return apiClient.get(API_ENDPOINTS.STATISTICS);
  },

  async getLicenseStatistics() {
    return apiClient.get(`${API_ENDPOINTS.STATISTICS}licenses/`);
  },

  async getClientStatistics() {
    return apiClient.get(`${API_ENDPOINTS.STATISTICS}clients/`);
  },

  async getRevenueStatistics(startDate, endDate) {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    
    const queryString = params.toString();
    const endpoint = queryString ? `${API_ENDPOINTS.STATISTICS}revenue/?${queryString}` : `${API_ENDPOINTS.STATISTICS}revenue/`;
    
    return apiClient.get(endpoint);
  },

  async getUsageStatistics(startDate, endDate) {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    
    const queryString = params.toString();
    const endpoint = queryString ? `${API_ENDPOINTS.STATISTICS}usage/?${queryString}` : `${API_ENDPOINTS.STATISTICS}usage/`;
    
    return apiClient.get(endpoint);
  },

  async getHealthCheck() {
    return apiClient.get(API_ENDPOINTS.HEALTH_CHECK);
  },
};
